import React from 'react';
import logo from '../assets/LOGO BLACK.png';
import iso27001 from '../assets/zoiISO.svg';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className=" mx-auto px-6 py-2 md:py-2 bg-white">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8 max-sm:gap-3">
        <div className="text-gray-600 text-center text-sm md:text-left">
          © {new Date().getFullYear()} thewhiteowl. All rights reserved.
        </div>

        <div className="flex items-center gap-4 order-first md:order-none">
          <img 
            src={logo} 
            alt="logo" 
            className="h-6 md:h-10 max-sm:h-10"
          />
          <img 
            src={iso27001} 
            alt="ISO 27001 Certification" 
            className="h-20 md:h-20"
          />
        </div>
        
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8 max-sm:mt-0">
          <div className="flex items-center gap-4 md:gap-6">
            <span onClick={() =>{navigate('/privacy')}} className="cursor-pointer text-gray-600 text-sm hover:text-gray-900">
              Privacy Policy
            </span>
            <span onClick={() =>{navigate('/terms')}} className="cursor-pointer text-gray-600 text-sm hover:text-gray-900">
              Terms of use
            </span>
          </div>

          <div className="flex items-center gap-4 mt-4 md:mt-0 max-sm:mt-0">
            <a href="https://www.linkedin.com/company/whiteowlai/" target="_blank" rel="noopener noreferrer">
              <img src="/linkedin.svg" alt="LinkedIn" className="h-5 w-5" />
            </a>
            { <a href="https://x.com/whiteowl_ai" target="_blank" rel="noopener noreferrer">
              <img src="/twitter.svg" alt="Twitter" className="h-5 w-5" />
            </a> }
            <a href="https://www.instagram.com/thewhiteowlai/" target="_blank" rel="noopener noreferrer">
              <img src="/instagram.svg" alt="Instagram" className="h-5 w-5" />
            </a>
            <a href="https://www.youtube.com/@whiteowlai" target="_blank" rel="noopener noreferrer">
              <img src="/youtube.svg" alt="YouTube" className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 